import React, { Component } from "react";
import { connect } from "react-redux";
import {
  updateAdminSystemFeedback,
  getAdminSystemFeedbackById,
} from "../../../actions/webinars";
import InputField from "components/InputField/InputField";

class EditFeedback extends Component {
  constructor(props) {
    super(props);

    this.state = {
      user_name: "",
      body: "",
    };
  }

  componentDidMount() {
    this.props.getSystemFeedback(this.props.params.id);
  }

  componentDidUpdate(prev) {
    if (this.props.feedback.body !== prev.feedback.body) {
      this.setState({
        body: this.props.feedback.body,
        user_name: this.props.feedback.user_name,
      });
    }
  }

  onFieldChange = (e) => {
    const data = {
      ...this.state,
      ...{
        [e.target.name]: e.target.value,
      },
    };

    this.setState(data);
  };

  render() {
    const { body, user_name } = this.state;

    return (
      <main className="site--width ">
        <h2 style={{ textAlign: "center" }}>Edit feedback</h2>
        <div className="container_form">
          <div className="section_form row">
            <InputField
              className="col s12"
              label={"User name"}
              onChange={this.onFieldChange}
              autoComplete="new-password"
              value={user_name}
              field_name="user_name"
            />
            <InputField
              className="col s12"
              label={"Body"}
              onChange={this.onFieldChange}
              autoComplete="new-password"
              value={body}
              field_name={"body"}
            />
          </div>
          <button
            style={{ display: "block", margin: "0 auto" }}
            className="button_classic"
            onClick={() =>
              this.props.updateAdminSystemFeedback({
                id: this.props.params.id,
                ...this.state,
              })
            }
          >
            Edit
          </button>
        </div>
      </main>
    );
  }
}

function mapStateToProps(state) {
  return {
    feedback: state.webinars.systemFeedback,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    getSystemFeedback: (params) => dispatch(getAdminSystemFeedbackById(params)),
    updateAdminSystemFeedback: (payload) =>
      dispatch(updateAdminSystemFeedback(payload)),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(EditFeedback);



// WEBPACK FOOTER //
// ./src/containers/Admin/EditFeedback/index.jsx